import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const skeletonVariants = cva("h-skeleton", {
  variants: {
    size: {
      sm: "h-skeleton--sm",
      default: "h-skeleton--default",
      lg: "h-skeleton--lg",
      freeform: "",
    },
    noAnimate: {
      true: "h-skeleton--no-animate",
    },
  },
  defaultVariants: {
    size: "default",
  },
})

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof skeletonVariants> {
  "aria-label"?: string
}

function Skeleton({ className, size, noAnimate, "aria-label": ariaLabel, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(skeletonVariants({ size, noAnimate }), className)}
      aria-busy="true"
      aria-label={ariaLabel || "Loading"}
      {...props}
    />
  )
}

export { Skeleton }
